module.exports = __webpack_public_path__ + "media/images/illustrations/protection_plan_standard-317fc125a59570ea549a5a6c4b89da73.svg";